var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7451 11.3979L9.17647 9.82927L9.96078 9.04496L11.1373 10.2214L10.7451 11.3979Z",
    fill: "#70707B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96078 11.0057V9.82927H11.1373L14.6667 13.3587L13.4902 14.5352L9.96078 11.0057Z",
    fill: "#70707B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43137 9.82927C8.38061 9.82927 9.96078 8.2491 9.96078 6.29986C9.96078 4.35062 8.38061 2.77045 6.43137 2.77045C4.48213 2.77045 2.90196 4.35062 2.90196 6.29986C2.90196 8.2491 4.48213 9.82927 6.43137 9.82927ZM6.43137 11.3979C9.24694 11.3979 11.5294 9.11543 11.5294 6.29986C11.5294 3.48429 9.24694 1.20182 6.43137 1.20182C3.6158 1.20182 1.33333 3.48429 1.33333 6.29986C1.33333 9.11543 3.6158 11.3979 6.43137 11.3979Z",
    fill: "#70707B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.94c2170f.svg";
export { ForwardRef as ReactComponent };